import React from 'react';
import { BaseAddressInput } from 'src/components/BaseAddressInput/BaseAddressInput';
import { INPUT_REGEX } from 'src/utilities/regexPatterns';

export interface InvoiceContactAddress2ControlProps {
  name: string;
  id: string;
}

export function InvoiceContactAddress2Control({
  name,
  id,
}: InvoiceContactAddress2ControlProps): JSX.Element {
  return (
    <BaseAddressInput
      name={name}
      id={id}
      label="Address 2"
      placeholder="e.g. 15"
      rules={{
        pattern: {
          value: INPUT_REGEX,
          message: 'Address 2 is invalid',
        },
      }}
    />
  );
}
